/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Partner_Billing_Board_Sync_MinutesInputs */



/**
* | output |
* | --- |
* | "Accounting sync · {minutes}m ago" |
*
* @param {Partner_Billing_Board_Sync_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_sync_minutes = /** @type {((inputs: Partner_Billing_Board_Sync_MinutesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Sync_MinutesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Buchhaltungsabgleich · vor ${i?.minutes} Min.`)
	return /** @type {LocalizedString} */ (`Accounting sync · ${i?.minutes}m ago`)
});